import React from "react";
import { Skeleton, ErrorState } from "../ui/LoadingStates";

const TYPE_COLORS = {
  annual:   { bar: "#00ff90", text: "text-[#00ff90]" },
  sick:     { bar: "#f87171", text: "text-red-400"   },
  casual:   { bar: "#c084fc", text: "text-purple-400" },
  unpaid:   { bar: "#fbbf24", text: "text-yellow-400" },
  maternity:{ bar: "#60a5fa", text: "text-blue-400"  },
  paternity:{ bar: "#34d399", text: "text-emerald-400"},
};

function getColor(type = "") {
  return TYPE_COLORS[type.toLowerCase()] || { bar: "#00ff90", text: "text-[#00ff90]" };
}

export default function LeaveBalanceSummary({ balances = [], loading, error, onRetry }) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {[1, 2, 3].map(i => (
          <div key={i} className="rounded-xl border border-[#00ff90]/20 bg-[#0d0d0d] p-4"
               style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Skeleton width={80} height={10} />
              <Skeleton width={48} height={22} />
            </div>
            <Skeleton width="100%" height={6} radius={999} />
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Skeleton width={60} height={9} />
              <Skeleton width={60} height={9} />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    return <ErrorState message="Couldn't load leave balances" detail={error} onRetry={onRetry} />;
  }

  if (!balances.length) {
    return (
      <div className="rounded-xl border border-[#00ff90]/20 bg-[#0d0d0d] p-4 text-white/20 text-sm italic">
        No leave balances available.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {balances.map((b, i) => {
        const remaining = (b.total ?? 0) - (b.used ?? 0);
        const pct = b.total > 0 ? Math.max(0, Math.min(100, (remaining / b.total) * 100)) : 0;
        const { bar, text } = getColor(b.type);
        return (
          <div key={i} className="rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022] p-4">
            <div className="flex items-center justify-between mb-3">
              <span className={`text-xs uppercase tracking-widest font-medium ${text}`}>{b.type}</span>
              <span className={`text-2xl font-bold ${text}`}>{remaining}</span>
            </div>
            {/* Progress bar */}
            <div className="h-1.5 rounded-full bg-white/5 mb-3">
              <div className="h-full rounded-full transition-all" style={{ width: `${pct}%`, background: bar }} />
            </div>
            <div className="flex justify-between text-xs text-white/30">
              <span>{b.used ?? 0} used</span>
              <span>{b.total ?? 0} total</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}